<button #rowBtn class="af-row" type="button" [class.pi-row]="variant === 'pinned-inactive'" (click)="onClick()" [title]="'Open ' + dimLabel + ' filter'">
  <span class="af-pin" [class.is-empty]="!pinned" aria-hidden="true">
    <svg viewBox="0 0 24 24" stroke="none" fill="currentColor">
      <path d="M12 2a1 1 0 011 1v4.27l1.6 1.07a3 3 0 011.32 2.27L16.4 13H7.6l.48-2.39a3 3 0 011.32-2.27L11 7.27V3a1 1 0 011-1z"/>
      <path d="M11 14h2v8h-2z"/>
    </svg>
  </span>
  <span class="af-dim">{{ dimLabel }}</span>
  <span class="af-arrow" aria-hidden="true">▸</span>
  <span class="af-value">{{ valueSummary }}</span>
  <span class="af-count" [class.is-empty]="!count">{{ count }}</span>
  <svg class="af-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9 6l6 6-6 6"/>
  </svg>
</button>
